import { render } from "./Badge6.vue?vue&type=template&id=01fd3d76&scoped=true"
import script from "./Badge6.vue?vue&type=script&lang=js"
export * from "./Badge6.vue?vue&type=script&lang=js"

import "./Badge6.vue?vue&type=style&index=0&id=01fd3d76&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01fd3d76"]])

export default __exports__